import { useState, useEffect } from 'react';

/**
 * Custom hook that debounces a value by a specified delay in milliseconds.
 * Useful for delaying search input queries until the user stops typing.
 */
export function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
